import axios from 'axios';
import { REACT_APP_API } from '../../config';

export async function updateTaskById(id,body) {

  try {
    return await axios.put(`${REACT_APP_API}/leadtasks/${id}`, body)
  } catch {    
    throw new Error()
  }

}